import { PurchaseCommissionRepository } from '../repositories/purchase-commission.repository';
import { PurchaseCommissionRepositoryService } from '../repositories/purchase-commission.service';

export const PurchaseCommissionProvider = [
  {
    provide: PurchaseCommissionRepository,
    useClass: PurchaseCommissionRepositoryService,
  },
];
